<script>
  export let width = 0;
</script>

<div id="line" style="width:{width}px" />

<style>
  #line {
    height: 1px;
    background-color: #000000;
  }
</style>
